import type { WithdrawalToken } from '../flow/withdrawalFlowConfig'
import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { chainIconUri, chainName } from '../utils/chainDisplay'
import { SelectedChainRow } from './SelectedChainRow'

export interface ReceiveAsRowProps {
  /** The picked destination, or `undefined` while the list is resolving. */
  destinationToken: WithdrawalToken | undefined
  /** Opens the receive-token picker. */
  onPress: () => void
}

/**
 * What the withdrawal is received as, and the way to change it. Shared by the
 * screens that show it — the row is the same on both, and a second copy is how
 * the label and the token/chain wording drift apart.
 */
export function ReceiveAsRow({ destinationToken, onPress }: ReceiveAsRowProps) {
  const { t } = useFunkitTranslation()
  const label = t('withdrawCrypto.receiveAs')

  return (
    <SelectedChainRow
      label={label}
      name={
        destinationToken
          ? `${destinationToken.symbol} · ${
              chainName(Number(destinationToken.chainId)) ??
              t('networks.chainFallback', {
                chainId: destinationToken.chainId,
              })
            }`
          : t('common.loading')
      }
      iconUri={chainIconUri(
        destinationToken ? Number(destinationToken.chainId) : 0,
      )}
      accessibilityLabel={label}
      onPress={onPress}
    />
  )
}
